<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center; font-size: 16pt; margin-bottom: 45px;"><strong><em>Apocalypse Dawn</em></strong></p>
<p style="text-align: center;">is dedicated to</p><br/>
<p style="text-align: center;">Howard and Valda Broadstock</p>
<p style="text-align: center;">Ron and Ruth Bennett</p>
<p style="text-align: center;">Brian and Mavis Everett—</p>
<p style="text-align: center;">Leaders</p>
<p style="text-align: center;">Christian examples</p>
<p style="text-align: center;">Mentors—</p>
<p style="text-align: center;">through my childhood and youth.</p>
<p style="text-align: center;">Their challenge and encouragement</p>
<p style="text-align: center;">are remembered with joy.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?7661c5a3